import { gql } from '@apollo/client';
import { BookingStepFragmentDoc } from './booking-step.fragment';
export const BookingStepsTemplateDocument = gql `
  query bookingStepsTemplate {
    bookingStepsTemplate {
      ...BookingStep
    }
  }
  ${BookingStepFragmentDoc}
`;
